// extracted by extract-css-chunks-webpack-plugin
module.exports = {"play-button":"FtT7A","video-wrapper":"FyPj1"};